module.exports = __webpack_public_path__ + "../resources/img/footer_logo.b3ee8a5a.png";